module.exports = __webpack_public_path__ + "img/wl_prod2_4.4dbffca4.jpg";